import {GROUP_TYPE, getTextColor, GROUP_SECTION_WIDTH, drawRectangle, getTrimmedText} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {profilePicSrc} from '../../../../constants';
import Util from '../../../../forecast-app/shared/util/util';

class PersonGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PERSON, data);
		this.groupIds = data.groupIds;
	}

	draw(canvasContext, x, y) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, groupType} = this;
		super.draw(x, y, width, height, this);
		const {id, firstName, lastName, role, profilePictureId, personId, onPersonImageLoad} = data;
		const cacheId = `${groupType}-${id}`;

		drawRectangle(canvasContext, x + 10, y - 1, width - 10, height + 1, {
			borderColor: '#ebebee',
			borderThickness: 1,
		});

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			return;
		}

		const textColor = getTextColor();

		const drawGroup = personImage => {
			canvasContext.font = '14px ' + Util.getFontFamily();
			canvasContext.fillStyle = textColor;
			canvasContext.font = '500 12px ' + Util.getFontFamily();
			const name = `${firstName} ` + (lastName || '');
			canvasContext.fillText(getTrimmedText(canvasContext, name), x + 52, y + 14);
			canvasContext.fillStyle = '#a1a1a1';
			canvasContext.font = '400 11px ' + Util.getFontFamily();
			canvasContext.fillText(getTrimmedText(canvasContext, role), x + 52, y + 30);
			if (personImage) {
				canvasContext.drawImage(personImage, x + 16, y + 2, 30, 30);
			} else {
				canvasContext.beginPath();
				const xOrigin = x + 32,
					yOrigin = y + 3;
				canvasContext.moveTo(xOrigin, yOrigin);
				canvasContext.lineTo(xOrigin, yOrigin);
				canvasContext.lineTo(xOrigin + 13, yOrigin + 7, 575);
				canvasContext.lineTo(xOrigin + 13, yOrigin + 22, 425);
				canvasContext.lineTo(xOrigin, yOrigin + 30);
				canvasContext.lineTo(xOrigin, yOrigin + 30);
				canvasContext.lineTo(xOrigin - 13, yOrigin + 22, 425);
				canvasContext.lineTo(xOrigin - 13, yOrigin + 7, 575);
				canvasContext.fillStyle = '#6e0fea';
				canvasContext.fill();
				if (name) {
					canvasContext.font = '700 10px ' + Util.getFontFamily();
					canvasContext.fillStyle = 'white';
					const initials = Util.getInitials(name);
					canvasContext.textAlign = 'center';
					canvasContext.fillText(getTrimmedText(canvasContext, initials.toUpperCase()), xOrigin, yOrigin + 18);
				}
				canvasContext.textAlign = 'start';
			}
		};

		const cachedImage = cacheManager.get('personImage', personId);

		if (cachedImage && profilePictureId) {
			drawGroup(cachedImage);
		} else {
			if (profilePictureId) {
				const personImage = new Image();
				personImage.onload = () => {
					cacheManager.set('personImage', personId, personImage);
					onPersonImageLoad();
				};
				personImage.src = profilePicSrc(profilePictureId);
			}
			drawGroup(null);
		}
	}
}

export default PersonGroup;
